module.exports = __webpack_public_path__ + "img/97.1.0c788e38.jpg";